import { jsx as e } from "react/jsx-runtime";
import { DefaultPaymentButton as c } from "./components/default-payment-button.mjs";
import { MercadoPagoCardPaymentButton as o } from "./mercado-pago/card/payment-button.mjs";
import { PaypalRestPaymentButton as n } from "./paypal/paypal-rest-payment-button.mjs";
import { PaypalSoapPaymentButton as d } from "./paypal/paypal-soap-payment-button.mjs";
import { RazorpayPaymentButton as p } from "./razorpay/components/payment-button.mjs";
import { StripeCardPaymentButton as u } from "./stripe/stripe-card/components/stripe-card-payment-button.mjs";
import { XenditPaymentButton as _ } from "./xendit/xendit-payment-button.mjs";
import { PaymentMethodEnum as r } from "@systemeio/ui";
import { RedirectBasedPaymentButton as t } from "./stripe/components/redirect-based-payment-button.mjs";
const R = (m, a) => {
  switch (m) {
    case r.stripe_card:
      return /* @__PURE__ */ e(u, { ...a });
    case r.stripe_ideal:
      return /* @__PURE__ */ e(t, { ...a });
    case r.stripe_bancontact:
      return /* @__PURE__ */ e(t, { ...a });
    case r.stripe_klarna:
      return /* @__PURE__ */ e(t, { ...a });
    case r.paypal_rest:
      return /* @__PURE__ */ e(n, { ...a });
    case r.paypal_soap:
      return /* @__PURE__ */ e(d, { ...a });
    case r.mercadopago_ar_card:
    case r.mercadopago_br_card:
    case r.mercadopago_cl_card:
    case r.mercadopago_co_card:
    case r.mercadopago_mx_card:
      return /* @__PURE__ */ e(o, { ...a });
    case r.razorpay:
      return /* @__PURE__ */ e(p, { ...a });
    case r.xendit_id_card:
    case r.xendit_ph_card:
      return /* @__PURE__ */ e(_, { ...a });
    default:
      return /* @__PURE__ */ e(c, { ...a });
  }
};
export {
  R as getPaymentProcessorPaymentButton
};
